import { twMerge } from 'tailwind-merge';
import type { DecoratedTask } from '@witmetrics/utils';
import {
  formatDateOnlyTime,
  formatDateWithTime,
  isPast,
  isToday,
  isTomorrow,
} from '@witmetrics/utils/time';
import {
  useDateFormatPreference,
  useTimeFormatPreference,
} from '@witmetrics/data-store';
import { TimeIcon } from '@/icons';
import { classes } from './utils';

export type DueDateProps = {
  onlyTime?: boolean;
  task: DecoratedTask;
};

export default function DueDate({ onlyTime, task }: DueDateProps) {
  const dateFormat = useDateFormatPreference();
  const timeFormat = useTimeFormatPreference();

  let dateClasses = [classes.dueAt];
  let time = onlyTime
    ? formatDateOnlyTime(task.dueAt, timeFormat)
    : formatDateWithTime(task.dueAt, dateFormat, timeFormat);
  if (task.isResolved) {
    dateClasses.push(classes.resolved);
  } else if (isToday(task.dueAt)) {
    time = 'Due today';
    dateClasses.push(classes.today);
  } else if (isTomorrow(task.dueAt)) {
    time = 'Due tomorrow';
    dateClasses.push(classes.tomorrow);
  } else if (isPast(task.dueAt)) {
    dateClasses.push(classes.past);
  }
  return (
    <div className={classes.wrapper}>
      <TimeIcon className={classes.icon} />
      <div className={twMerge(...dateClasses)}>{time}</div>
    </div>
  );
}
